import { loginGuest } from 'api/api';
import { getAllParamsFormUrl } from 'utils/getAllParamsFormUrl';

interface UseHandleLoginProps {
  setApAuthError: (error: string | undefined) => void;
  setIsStartAuthorizingToAP: (isStartAuthorizingToAP: boolean) => void;
  setIsAuthorizationRequestSuccess: (isAuthorizationRequestSuccess: boolean) => void;
}

export const useHandleLogin = ({
  setApAuthError,
  setIsStartAuthorizingToAP,
  setIsAuthorizationRequestSuccess,
}: UseHandleLoginProps) => {
  const params = getAllParamsFormUrl();

  return async () => {
    setApAuthError(undefined);
    setIsStartAuthorizingToAP(true);
    try {
      if (!params.macAddress) {
        throw new Error('macAddress is required');
      }
      const response = await loginGuest({
        macAddress: params.macAddress,
        ...(params.siteName && { siteName: params.siteName }),
        ...(params.ssid && { ssid: params.ssid }),
        ...(params.apMacAddress && { apMacAddress: params.apMacAddress }),
      });
      if (!response?.isSuccess) {
        setApAuthError('authSignInError');
        setIsAuthorizationRequestSuccess(true);
        throw new Error('authSignInError');
      }
      return response;
    } catch (error) {
      setApAuthError('authSignInError');
      setIsAuthorizationRequestSuccess(true);
      throw new Error(error instanceof Error ? error.message : 'Unknown error');
    }
  };
};
